import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import DocumentUpload from './components/document-upload';
import axios from 'axios';

function App() {
  const [documentType, setDocumentType] = useState('certificate');
  const [entityPayload, setEntityPayload] = useState({});
  const [documentTypes, setDocumentTypes] = useState([]);
  const [apiData, setApiData] = useState(null);
  const [uploadFor, setUploadFor] = useState(null);
  const [isS3UploadRequired, setIsS3UploadRequired] = useState(false);
  const [nurseId, setNurseId] = useState(null);
  const [platform, setPlatform] = useState(null);

  const handleMessage = useCallback(
    (event) => {
      // In production, you would check event.origin for security
      // if (event.origin !== "https://allowed-origin.com") return;

      let parsedData;
      try {
        parsedData = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      } catch (e) {
        return;
      }

      // Only process if we have data with a type and data property
      if (parsedData?.type && parsedData?.data) {
        const messageTypes = {
          CERTIFICATE_OPTIONS: 'certificate',
          DOCUMENT_OPTIONS: 'document'
        };
        if (parsedData.type === 'DOCUMENT_SUBMISSION_RESULT') {
          const data = {
            id: parseInt(parsedData.data?.webhook?.entity_id),
            cv_id: apiData?.cv_id,
            formData: apiData?.formData,
            submissionResult: parsedData.data
          };
          const config = {
            method: 'post',
            url: apiData?.url,
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios
            .request(config)
            .then((res) => {
              console.log('---res---', res);
            })
            .catch((err) => {
              console.log('---err---', err);
            });
        }
        const docType = messageTypes[parsedData.type];
        if (docType) {
          setDocumentType(docType);

          // Extract S3 upload config from message
          if (parsedData.uploadFor) setUploadFor(parsedData.uploadFor);
          if (parsedData.isS3UploadRequired !== undefined)
            setIsS3UploadRequired(parsedData.isS3UploadRequired);
          if (parsedData.nurseId) setNurseId(parsedData.nurseId);
          if (parsedData.platform) setPlatform(parsedData.platform);

          if (parsedData.newDoc) {
            // Handle new request - data contains array of options
            setDocumentTypes(parsedData.data);
            setEntityPayload({});
          } else {
            // Handle existing document - data contains document details
            setEntityPayload(parsedData.data);
          }
        }
      }
    },
    [apiData]
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);

  function onFileSubmit(data) {
    setApiData(data);
  }

  return (
    <div className="App">
      <DocumentUpload
        documentType={documentType}
        entityPayload={entityPayload}
        documentTypes={documentTypes}
        onFileSubmit={onFileSubmit}
        uploadFor={uploadFor}
        isS3UploadRequired={isS3UploadRequired}
        nurseId={nurseId}
        platform={platform}
      />
    </div>
  );
}

export default App;
